import { render, staticRenderFns } from "./dashboard-spoc.vue?vue&type=template&id=827a6d58"
import script from "./dashboard-spoc.js?vue&type=script&lang=js&external"
export * from "./dashboard-spoc.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports